import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Lock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            grupo_id: null,
            departamento_id: null,
            departamentopadre_id: null,
            pk: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }


    ResetForm() {
        this.setState({
            grupo_id: null,
            departamento_id: null,
            departamentopadre_id: null,
            pk: null,
        });
    }

    setSelects(data) {
        this.setState({
            pk: data.pk,
            grupo_id: data.grupo_id,
            departamento_id: data.departamento_id,
            departamentopadre_id: data.departamentopadre_id,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.usuarios.lock}
                postUrl={api.usuarios.usuarios.lock}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Usuario ha sido deshabilitado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Deshabilitar login de Usuario"}
                buttonTitle={"Deshabilitar login Usuario"}
                buttonIcon={"fa fa-lock fa-lg"}

                saveButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.ResetForm()}
                closeButton={true}>
                <Row>
                    <Col className="col-2">
                        <Label>Apellido</Label>
                    </Col>
                    <Col className="col-10">
                        <Input disabled={true} type="text" name="apellido"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input disabled={true} type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>DNI</Label>
                    </Col>
                    <Col className="col-10">
                        <Input disabled={true} type="text" name="dni"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Domicilio</Label>
                    </Col>
                    <Col className="col-10">
                        <Input disabled={true} type="text" name="domicilio"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Email</Label>
                    </Col>
                    <Col className="col-10">
                        <Input disabled={true} type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Teléfono</Label>
                    </Col>
                    <Col className="col-10">
                        <Input disabled={true} type="text" name="telefono"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>


                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Grupo</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker
                            disabled={true}
                            fieldName={""}
                            url={api.usuarios.grupos.select}
                            onChange={(data) => this.setState({ departamentopadre_id: (data != null ? data.pk : 0), departamento_id: null })}
                            value={this.state.departamentopadre_id} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Subgrupo</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker
                            disabled={true}
                            fieldName={"departamento_id"}
                            url={api.usuarios.subgrupos.select + (this.state.departamentopadre_id ? "?grupo=" + this.state.departamentopadre_id : "")}
                            onChange={(data) => this.setState({ departamento_id: (data != null ? data.pk : 0) })}
                            value={this.state.departamento_id} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className="mt-2">
                    <Col className="col-12">
                        <Label className="w-100 text-center">Datos de Login</Label>
                    </Col>
                </Row>

                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Usuario</Label>
                    </Col>
                    <Col className="col-10">
                        <Input disabled={true} type="text" name="username"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Lock;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Usuarios/Lock.js